<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12>
        <h1>
          {{ $tc('csvAddressImport') }}
        </h1>

        <h1>
          <v-btn color="primary" @click="save" outline :loading="loading" :disabled="loading" v-if="inputFile"> {{ $t('save') }} </v-btn>
          <v-btn color="primary" outline @click="back"> {{ $t('back') }} </v-btn>

          <v-btn text color="primary" link href="https://6dfb173c-ee1e-4b44-a0b8-cfe67c3bef34.s3.us-west-2.amazonaws.com/samples/addresses.xlsx" target="_blank"> {{ $t('downloadExample') }} </v-btn>
        </h1>
      </v-flex>

      <v-flex xs12>
        <v-alert :value="true" color="error" icon="warning" outline v-html="$t('importAddressesAlert')"></v-alert>
      </v-flex>

      <v-flex xs12>
        <v-card>
          <v-card-text>
            <v-layout wrap>
              <v-flex xs12 md4>
                <v-text-field :label="$t('selectFile')" @click="pickFile" v-model="filename" prepend-icon="attach_file"></v-text-field>
                <input type="file" style="display: none" ref="file" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" @change="onFilePicked">
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Address from '@/client/address'

export default {
  name: 'AddressesImportView',

  props: {},

  data () {
    return {
      filename: '',
      inputFile: '',
      loading: false
    }
  },

  components: {
  },

  computed: {
  },

  methods: {
    onFilePicked (e) {
      this.loading = true
      this.errors.clear()

      this.inputFile = e.target.files[0]
      this.filename = this.inputFile.name
      this.loading = false
    },

    pickFile () {
      this.$refs.file.click()
    },

    async save () {
      const isValid = await this.$validator.validateAll()
      if (!isValid) { return }

      this.loading = true
      try {
        const formData = new FormData()
        formData.append('files[]', this.inputFile)
        await Address.importCsv(formData)
        this.setNotification({
          color: 'success',
          message: 'Addresses imported successfully.'
        })
        this.back()
      } catch (err) {
        this.handleErr(err)
      }
      this.loading = false
    }
  },

  watch: {
  },

  async mounted () {
  }
}
</script>
